export default __webpack_public_path__ + "static/1760-9a8a54467174be5e9d23ecd259333dbe.gif";